/* eslint-disable import/prefer-default-export */
import DOMPurify from 'dompurify';

export const forbiddenTags = [
  'input', 'button', 'iframe', 'applet', 'embed', 'object',
  'script', 'meta', 'audio', 'canvas', 'frameset', 'noframes', 'noscript', 'track',
];

export function sanitize(dirtyHtml) {
  return DOMPurify.sanitize(dirtyHtml, { FORBID_TAGS: forbiddenTags });
}
